import styled from "styled-components";
import "@fontsource/lexend";
import "@fontsource/bebas-neue";
import "@fontsource/merriweather";
import "@fontsource/montserrat"; 


export const DesktopOnly = styled.div`
  display: block;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileOnly = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;

export const ServicesPageContainer = styled.div`
    background: #282c34;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    height: 100vh;
    position: relative;
    z-index: 1;
    
    @media screen and (max-width: 900px) { 
        height: 1250px;
    }
    
    @media screen and (max-width: 800px) { 
        height: 1100px;
    }
        
    @media screen and (max-width: 700px) { 
        height: 935px;
    }
`;

export const ServicePageOverlay = styled.div`
  position: absolute;
  inset: 0; /* top:0; right:0; bottom:0; left:0 */
  background: rgba(0, 0, 0, 0.40); /* 30% black */
  z-index: 2; /* sits above video but below text */
`;

export const ServicePageBg = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width:100%;
    height: 100%;
    overflow: hidden;
`;

export const ServicePageContent = styled.div`
  position: absolute;
  margin-top: -80px;
  z-index: 3;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const ServicePageTitle = styled.h2`
  font-family: "Merriweather";
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 1.25;
  padding-top: 140px; /* default desktop padding */
  font-size: 44px;

  @media screen and (max-width: 1024px) {
    text-align: left;
    font-size: 24px;
  }

  @media screen and (max-width: 768px) {
  text-align: left;
  font-size: 20px;
  }

  @media screen and (max-width: 480px) {
    text-align: left;
    font-size: 16px;
  }
`;

export const ServicePageSecondContent = styled.div`
    z-index: 3;
    padding: 8px 24px;
    padding-top: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background:rgba(0, 0, 0, 1);
`;

export const ServicePageSubText = styled.h3`
    color: #f0f0f0;
    font-size: 20px;
    text-align: center;
    font-family: "montserrat";
    font-weight: 400;
    max-width: 560px;
    
   @media screen and (max-width: 768px) { 
        font-size: 18px;
        text-align: justify;
        max-width: 100%;
    }
    
   @media screen and (max-width: 480px) { 
        font-size: 16px;
        text-align: justify;
        max-width: 100%;
    }
`;

export const ServicePageSubTextBottom = styled.h3`
    color: #f0f0f0;
    font-size: 20px;
    text-align: center;
    font-family: "montserrat";
    font-weight: 400;
    max-width: 560px;
    
   @media screen and (max-width: 768px) { 
        font-size: 18px;
        max-width: 100%;
    }
    
   @media screen and (max-width: 480px) { 
        font-size: 16px;
        max-width: 100%;
    }
`;

export const ServicesPricingSection = styled.section`
  background:rgba(0, 0, 0, 1);
  padding: 48px 24px 64px;
  z-index: 3;
`;

